import React from "react";
import styled from "styled-components";
import { Container, Row, Col } from "react-bootstrap";
import { getImage, GatsbyImage } from "gatsby-plugin-image";
import { useIntl, Link } from "gatsby-plugin-intl";

import Button from "../Button";

const Title = styled.h2`
  color: ${props => props.theme.colors.gray};
  text-transform: uppercase;
  letter-spacing: 0.1em;
  position: relative;
`;

const ProjectTitle = styled.h3`
  letter-spacing: 0.1em;
  font-size: 1.2rem;
  a {
    color: inherit;
  }
`;

const ImageFrame = styled.div`
  position: relative;
  &:after {
    content: "";
    display: block;
    position: absolute;
    width: 100%;
    height: 100%;
    border: solid 0px #fff;
    top: 0;
    left: 0;
    transition: all 0.3s ease-in-out;
  }
  &:hover {
    &:after {
      border-width: 10px;
    }
  }
`;

const RecentProjects = ({ projects }) => {
  const intl = useIntl();

  return (
    <Container fluid className="pt-5 mt-5">
      <Title className="text-center mb-5">
        {intl.formatMessage({ id: "recent_projects" })}
      </Title>
      <Row className="justify-content-around">
        {projects.map(project => {
          const image = getImage(project.data.cover.localFile.childImageSharp);
          return (
            <Col key={project.uid} md={3} className="mb-5 mb-md-0">
              <div className="d-block" data-sal="slide-up">
                <Link to={`/proyectos/${project.uid}`}>
                  <ImageFrame className="mb-4">
                    <GatsbyImage
                      image={image}
                      alt={project.data.cover.alt || ""}
                    />
                  </ImageFrame>
                </Link>
                <ProjectTitle className="mb-3">
                  <Link to={`/proyectos/${project.uid}`}>
                    {project.data.title.text}
                  </Link>
                </ProjectTitle>
                <Button to={`/proyectos/${project.uid}`}>
                  {intl.formatMessage({ id: "view_more" })}
                </Button>
              </div>
            </Col>
          );
        })}
      </Row>
    </Container>
  );
};

export default RecentProjects;
